<ppl-box-container-with-title [title]="title"
                              [description]="description"
                              [small]="true">
  <ppl-error-box *ngIf="error">
    <ng-container [ngSwitch]="error">
      <ng-container *ngSwitchCase="LoginError.ERROR_INCORRECT_LOGIN">
        <span i18n="@@Login_incorrect_login_error">There was an error with your E-Mail/Password combination.</span>
        <span>&nbsp;</span>
        <a href="https://support.pipelinersales.com"
           target="_blank"
           i18n="@@Do_you_need_help?">Do you need help?</a>
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_SESSION_EXPIRED"
                    i18n="@@This_link_is_not_valid_anymore.">
        This link is not valid anymore.
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_INVALID_MESSAGE"
                    i18n="@@Invalid_request_data_sent.">
        Invalid request data sent.
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_3RD_PARTY_AUTH_FAILED"
                    i18n="@@Authentication_with_your_IDP_provider_failed.">
        Authentication with your IDP provider failed.
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_UNKNOWN_USER">
        <ng-container i18n="@@The_account_doesn't_exist._You_need_an_invitation_or_you_can_create_a_new_account">
          The account doesn't exist. You need an invitation or you can <a href="https://www.pipelinersales.com/crm/free-trial" target="_blank" tabindex="-1">Create a new account</a>.
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_UNEXPECTED_USER"
                    i18n="@@LoginSuccessfullButUnexpectedUser">
        User {{ errorInfo.current_username }} can not login with active user {{ errorInfo.expected_username }}. Please try to login with different (not AD authenticated) browser.
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_ACCOUNT_DISABLED"
                    i18n="@@The_account_is_inactive.">
        The account is inactive.
      </ng-container>
      <ng-container *ngSwitchCase="LoginError.ERROR_TOO_MANY_FAILED_LOGIN_ATTEMPTS"
                    i18n="@@LoginFailedTooManyFailedAttempts">
        Your login is temporarily blocked as you reached the maximum number of unsuccessful attempts to log in. Try to login in a few minutes.
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="error_str; else unknownError">
          <span i18n="@@Error">Error</span><span>: {{ error_str }}</span>
        </ng-container>
        <ng-template #unknownError>
          <span i18n="@@Unknown_error.">Unknown error.</span>
        </ng-template>
      </ng-container>
    </ng-container>
  </ppl-error-box>
  <ng-content></ng-content>

  <ppl-loading-overlay *ngIf="loading"
                       [large]="true"
                       [visible]="true"
                       [inverse]="true"></ppl-loading-overlay>
</ppl-box-container-with-title>

<div class="copyright-login">
  <div class="copyright-login-row">
    <a href="https://www.pipelinersales.com/terms/"
       i18n="@@Terms_&_Conditions"
       class="link"
       target="_blank">Terms & Conditions</a>

    <div class="separator"></div>

    <a href="https://www.pipelinersales.com/privacy/"
       i18n="@@Privacy_Policy"
       class="link"
       target="_blank">Privacy Policy</a>
  </div>
  <span>&copy; {{ currentYear }} Pipelinersales Inc.</span>
</div>
